import { css, keyframes } from "@emotion/react";
import styled from "@emotion/styled";

import { FONT_WEIGHT_BOLD, FONT_WEIGHT_NORMAL } from "@skilitics/designer-ui-components";

export const Thumbnail = styled.div`
  position: relative;
  display: flex;

  height: 100px;
  width: 100%;

  overflow: hidden;

  border-start-start-radius: 10px;
  border-end-start-radius: 10px;

  > img {
    width: 100%;

    object-fit: cover;
  }
`;

export const DetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 5px;

  width: 100%;
  height: 100%;

  padding: 4px 0;

  font-size: 16px;
  color: ${({ theme }) => theme.generalTextIcon};
`;

export const Title = styled.div`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;

  font-weight: ${FONT_WEIGHT_BOLD};

  overflow: hidden;
`;

export const Description = styled.div`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;

  font-size: 14px;
  font-weight: ${FONT_WEIGHT_NORMAL};

  overflow: hidden;
`;

export const Tags = styled(Description)``;

export const Label = styled.span``;

export const MenuContainer = styled.div`
  display: flex;
  align-items: center;

  width: 100%;

  opacity: 0;

  transition: opacity 125ms ease-out;

  pointer-events: none;
`;

const glow = keyframes`
  from { 
    opacity: 1;
  }
  
  to {
    opacity: 0.15;
  }
`;

export const IconContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;

  display: grid;
  padding: 6px;

  & > * {
    grid-area: 1 / 1;
  }
`;

// Wrapper for the lock/trash icon handling animation and backdrop
// We want pointer-events: none so the tooltip on the user avatar behind this works.
export const IconWrapper = styled.div<{ $show: boolean; $busy?: boolean }>`
  pointer-events: none;
  color: ${({ theme }) => theme.generalTextIconFill};

  opacity: ${({ $show }) => ($show ? 1 : 0)};

  transition: opacity 300ms ease-in-out;

  padding: 4px;
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 50px;

  @supports (-webkit-backdrop-filter: none) or (backdrop-filter: none) {
    backdrop-filter: blur(8px);
  }

  ${({ $busy = false }) =>
    $busy &&
    css`
      animation: ${glow} 750ms ease-in-out infinite alternate;
    `};
`;
